export const copyToClipboard = (text) => {
  if (window.clipboardData && window.clipboardData.setData) {
    // Internet Explorer-specific code path to prevent textarea being shown while dialog is visible.
    return window.clipboardData.setData('Text', text)
  }
  if (document.queryCommandSupported && document.queryCommandSupported('copy')) {
    const textarea = document.createElement('textarea')
    textarea.textContent = text
    textarea.style.position = 'fixed' // Prevent scrolling to bottom of page in Microsoft Edge.
    document.body.appendChild(textarea)
    textarea.select()
    try {
      return document.execCommand('copy') // Security exception may be thrown by some browsers.
    } catch (ex) {
      console.warn('Copy to clipboard failed.', ex)
      return false
    } finally {
      document.body.removeChild(textarea)
    }
  }
}

export const copyToClipboardAsync = async (text) => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    try {
      await navigator.clipboard.writeText(String(text))
      return true
    } catch (_) {
      // Fall back for insecure contexts and browsers that deny Clipboard API access.
    }
  }

  return copyToClipboard(String(text)) === true
}

/**
 * Truncates a string from the middle, preserving the start and end.
 * @param {string} value
 * @param {number} prefixLength
 * @param {number} suffixLength
 * @returns {string}
 */
export const truncateMiddle = (value, prefixLength = 12, suffixLength = 4) => {
  if (!value) return ''
  const str = String(value)
  if (str.length <= prefixLength + suffixLength + 3) return str
  return `${str.slice(0, prefixLength)}...${str.slice(-suffixLength)}`
}
